module.exports = __webpack_public_path__ + "static/media/441894986_437807345693272_7813315455945709483_n.e3bcb03f.jpg";